(ns rothko.theme.manatee.layout
  (:refer-clojure :exclude [+ * rem])
  (:require [clojure.string :as string]
            [garden.arithmetic :refer [+ *]]
            [garden.units :refer [px rem]]
            [rothko.theme.sandi.header :as header]
            [rothko.theme.manatee.button :as button-theme]
            [rothko.theme.manatee.footer :as footer-theme]))

(def main
  {:main
   {:grid-area "main"
    :layout-item-width "100%"
    :padding-top (rem 2)
    :padding-bottom (rem 2)}

   :container
   {:width "100vw"
    :height "100vh"
    :display :grid
    :grid-template-columns " auto minmax(min-content, 1090px) auto"
    :grid-template-rows "auto 1fr auto"
    :grid-template-areas [["\"header header header\""
                           "\"left-gutter main right-gutter\""
                           "\"footer footer footer\""]]
    :layout-item-flex-grow 0
    :sticky-fallback-margin-bottom (+ button-theme/total-height
                                      (* 2 footer-theme/padding))
    :sticky-fallback-margin-bottom--large (+ button-theme/total-height--large
                                             (* 2 footer-theme/padding))}

   :column
   {:flex-direction :column
    :layout-item-flex-grow 1}

   :centered
   {:align-items :center
    :layout-item-flex-grow 1
    :justify-content :center}

   :shrink
   {:layout-item-flex-grow 0}})
